import { EditableProTable } from '@ant-design/pro-components';
import { Modal, Button, message, Divider } from 'antd';
import { nanoid } from 'nanoid';
import React, { useEffect, useMemo, useState } from 'react';
import { askLLMForCord } from '../utils/llm';
import { updateDB, cursorGetDataToList } from './indexedDB.js'

var cords = {};
const setCords = (list) => {
	list.forEach((item) => {
		cords[item.loc] = { lat: item.lat, lon: item.lon }
	})
}

const LocModal = (props) => {
	const { db, showing, dataSource, setDataSource } = props;
	const [unknownLocs, setUnknownLocs] = useState([]);
	const [asking, setAsking] = useState(false);
	const [asked, setAsked] = useState(false);
	const [forceRender, setForceRender] = useState(0);

	const [editableKeys, setEditableRowKeys] = useState([]);
	useEffect(() => {
		setEditableRowKeys(props.dataSource?.map(item => item.id))
	}, [props.dataSource])

	useEffect(() => {
		if (showing && db) {
			cords = {}
			cursorGetDataToList(db, "Cords", setCords)
		}
	}, [showing])

	const columns = [
		{
			title: '目标名称',
			dataIndex: 'name',
			width: '15%',
		},
		{
			title: '类型',
			dataIndex: 'type',
			width: '15%',
		},
		{
			title: '位置（逗号分隔）',
			dataIndex: 'loc',
			width: '40%',
		},
		{
			title: '操作',
			valueType: 'option',
			width: '10%',
			render: () => {
				return null;
			},
		},
	];

	const [editableLocKeys, setEditableLocRowKeys] = useState([]);
	useEffect(() => {
		setEditableLocRowKeys(unknownLocs?.map(item => item.id))
	}, [unknownLocs])

	const locColumns = [
		{
			title: '位置',
			dataIndex: 'loc',
			width: '40%',
			readonly: true,
		},
		{
			title: '经度',
			dataIndex: 'lon',
			width: '30%',
		},
		{
			title: '纬度',
			dataIndex: 'lat',
			width: '30%',
		},
	]

	const handleToMap = () => {
		const tempUnkownLocs = [];
		dataSource?.forEach((item) => {
			const locs = item.loc.replaceAll("，", ",").split(",").map(e => e.trim());
			try {
				locs.forEach((loc) => {
					if (!cords[loc]) {
						const foundItem = unknownLocs.find(item => item.loc === loc)
						if (foundItem) {
							const lat = parseFloat(foundItem.lat);
							const lon = parseFloat(foundItem.lon);
							if (lat && lon && lat <= 90 && lat >= -90 && lon <= 180 && lon >= -180) {
								updateDB(db, "Cords", { loc: loc, lat: lat, lon: lon })
								setCords([{ loc: loc, lat: lat, lon: lon }])
							} else {
								message.warning(`请输入地址【${foundItem.loc}】正确的坐标值`)
								throw new Error("invalid cords")
							}
						} else {
							if (tempUnkownLocs.findIndex(item => item.loc === loc) < 0) {
								tempUnkownLocs.push({ id: nanoid(), loc: loc, lon: "", lat: "" })
							}
						}
					}
				})
			} catch (error) {
				return;
			}
		});
		if (tempUnkownLocs.length > 0) {
			message.warning("部分位置的坐标未知")
			setUnknownLocs(tempUnkownLocs);
		} else {
			setUnknownLocs([]);
			props.tomap(cords);
		}
		setAsked(false);
	}

	const handleAsk = async () => {
		setAsking(true);
		let tempLocs = [];
		for (let i = 0; i < unknownLocs.length; i++) {
			try {
				const resp = await askLLMForCord(props.model, unknownLocs[i])
				tempLocs.push(resp)
			} catch (error) {
				console.log(error);
			}
		}
		setUnknownLocs(tempLocs);
		setAsked(true);
		setAsking(false);
		setForceRender(prev => prev + 1);
	}

	return (
		<Modal open={props.showing} width={'80%'} onCancel={() => { props.setShowing(prev => !prev) }} maskClosable={false}
			footer={[
				<Button size='small' key="tomap" type="primary" disabled={asking} onClick={handleToMap}>上图</Button>,
				<Button size='small' key="cancel" type="default" onClick={() => { props.setShowing(prev => !prev) }}>取消</Button>
			]}>
			<EditableProTable
				size='small'
				scroll={{ y: '40dvh' }}
				columns={columns}
				rowKey="id"
				value={dataSource}
				onChange={setDataSource}
				recordCreatorProps={{
					newRecordType: 'dataSource',
					record: () => ({
						id: nanoid(),
					}),
				}}
				editable={{
					type: 'multiple',
					editableKeys,
					actionRender: (row, config, defaultDoms) => {
						return [defaultDoms.delete];
					},
					onValuesChange: (record, recordList) => {
						setDataSource(recordList);
					},
					onChange: setEditableRowKeys,
				}}
			/>
			{unknownLocs.length === 0 ? '' :
				<>
					<Divider orientation='left'>以下位置的坐标未知{asked ? '' : asking ? '，询问大模型中……' : <a onClick={handleAsk} >，问问大模型</a>}</Divider>
					<EditableProTable
						key={forceRender}
						size='small'
						scroll={{ y: '40dvh' }}
						columns={locColumns}
						rowKey="id"
						value={unknownLocs}
						// onChange={() => { console.log("changing...") }}
						recordCreatorProps={{
							newRecordType: 'dataSource',
							record: () => ({
								id: nanoid(),
							}),
							style: {
								display: 'none',
							},
						}}
						editable={{
							type: 'multiple',
							editableKeys: editableLocKeys,
							onValuesChange: (record, recordList) => {
								const lat = parseFloat(record.lat);
								const lon = parseFloat(record.lon);
								if (lat && lon && lat <= 90 && lat >= -90 && lon <= 180 && lon >= -180) {
									updateDB(db, "Cords", { loc: record.loc, lat: lat, lon: lon })
									setCords([{ loc: record.loc, lat: lat, lon: lon }])
								}
							},
							onChange: setEditableLocRowKeys,
						}}
					/>
				</>
			}
		</Modal>
	);
};

export default LocModal;